import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { HardHat } from "@phosphor-icons/react";
import { StatusBadge, fmtBRL, fmtDate } from "@/lib/medicoes";

export default function MedicoesContratoPanel({ contractId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/contracts/${contractId}/medicoes`).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [contractId]);
  if (!items.length) return null;
  return (
    <div className="tce-card p-6" data-testid="contrato-medicoes-panel">
      <div className="flex items-center gap-2 uppercase-label !text-[#FFDF00] mb-4"><HardHat size={14} /> Medições do fornecedor ({items.length})</div>
      <div className="space-y-2">
        {items.map((m, i) => (
          <Link key={m.id} to={`/medicoes/${m.id}`} data-testid={`cmp-row-${i}`}
                className="flex flex-wrap items-center gap-3 text-sm py-2 border-b border-[#334155]/50 hover:text-[#FFDF00]">
            <span className="font-mono">nº {m.numero} v{m.versao}</span>
            <span className="text-[#94A3B8] text-xs">{fmtDate(m.periodo_inicio)} a {fmtDate(m.periodo_fim)}</span>
            <span className="font-mono ml-auto">{fmtBRL(m.valor_total)}</span>
            <StatusBadge status={m.status} valorPago={m.valor_pago} />
          </Link>
        ))}
      </div>
    </div>
  );
}
